import { useMemo } from "react";

export const useAnimations = (isMobile) => {
  return useMemo(() => {
    const reduced = isMobile;

    return {
      fadeInUp: {
        initial: { opacity: 0, y: reduced ? 20 : 60 },
        animate: {
          opacity: 1,
          y: 0,
          transition: { duration: reduced ? 0.3 : 0.6 },
        },
      },
      scaleIn: {
        initial: { scale: reduced ? 0.95 : 0.8, opacity: 0 },
        animate: {
          scale: 1,
          opacity: 1,
          transition: { duration: reduced ? 0.2 : 0.5 },
        },
      },
      slideIn: {
        initial: { x: reduced ? -20 : -100, opacity: 0 },
        animate: {
          x: 0,
          opacity: 1,
          transition: { duration: reduced ? 0.3 : 0.6 },
        },
      },
      slideInFromRight: {
        initial: { x: reduced ? 20 : 100, opacity: 0 },
        animate: {
          x: 0,
          opacity: 1,
          transition: { duration: reduced ? 0.3 : 0.5 },
        },
      },
      staggerChildren: {
        animate: {
          transition: {
            staggerChildren: reduced ? 0.1 : 0.2,
          },
        },
      },
    };
  }, [isMobile]);
};
